import React, { Component } from "react";
import {
  StyledBrandKitLogosGrid,
  StyledBrandkitSectionLabels,
} from "../../_components/styled/settings/stylesSettings";
import TldrDropzone from "../../_components/common/TldrDropzone";
import { connect } from "react-redux";
import { setCounter, uploadFile } from "../../_actions/storiesActions";
import BrandKitLogos from "./BrandKitLogos";
import { withTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import { fetchBrandkitById, switchBrandkit } from "../../_actions/brandKitActions";
import { handleHTTPError } from "../../_actions/errorHandlerActions";

class BrandKitLogosSection extends Component {
  render() {
    const { brandKit, brandKitInfo, workspacePermissionChecks, t, assetsDropzoneClassName } = this.props;
    const { canCreateBrandKitLogo } = workspacePermissionChecks;
    const { loaded } = brandKit;
    const { logos } = brandKitInfo;
    let brandLogosChild;
    if (loaded) {
      brandLogosChild =
        logos &&
        logos.map((logo, index) => {
          return (
            <BrandKitLogos
              key={index}
              logoInfo={logo}
              brandKitId={brandKitInfo.id}
            />
          );
        });
    }
    return (
      <Box w='100%'>
        <StyledBrandkitSectionLabels>
          <label>{t("brandkit.logos")}</label>
        </StyledBrandkitSectionLabels>
        {canCreateBrandKitLogo && (
          <TldrDropzone
            btnTitle={t("brandkit.upload_logos")}
            brandKitId={brandKitInfo.id}
            buttonWidth={this.props.isMobileView ? 75 : 25}
            onDrop={this.onLogosDrop}
            className={assetsDropzoneClassName}
          />
        )}
        {logos && logos.length > 0 && (
          <StyledBrandKitLogosGrid>{brandLogosChild}</StyledBrandKitLogosGrid>
        )}
      </Box>
    );
  }

  onLogosDrop = (droppedFiles, signalToken) => {
    const { brandKitInfo } = this.props;

    if (droppedFiles.length > 0) {
      this.props.setCounter(droppedFiles.length);
    }
    droppedFiles.forEach((file) => {
      this.props.uploadFile(
        file,
        { ...this.props, brandKitId: brandKitInfo.id },
        signalToken
      ).then(async () => {
        try {
          const responseData = await this.props.fetchBrandkitById(brandKitInfo.id);
          if (responseData) {
            this.props.switchBrandkit(responseData);
          }
        } catch (error) {
          this.props.handleHTTPError(error, this.props);
        }
      });
    });
  };
}

BrandKitLogosSection.propTypes = {};

const mapStateToProps = (state) => ({
  brandKit: state.brandKit,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  uploadFile: (file, props, signalToken) =>
    dispatch(uploadFile(file, props, signalToken)),
  setCounter: (counter) => dispatch(setCounter(counter)),
  fetchBrandkitById: (id) => dispatch(fetchBrandkitById(id)),
  switchBrandkit: (payload) => dispatch(switchBrandkit(payload)),
  handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
});

export default withTranslation(["planner"])(
  connect(mapStateToProps, mapDispatchToProps)(BrandKitLogosSection)
);
